import { render } from "./Charlas.vue?vue&type=template&id=f9ea80ac"
import script from "./Charlas.vue?vue&type=script&lang=js"
export * from "./Charlas.vue?vue&type=script&lang=js"
script.render = render

export default script